<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    this.checkWxAuth();
  },
  methods: {
    ensureAnonymousId() {
      const key = 'yunhai_anon_id';
      let id = localStorage.getItem(key);
      if (id) return id;
      if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        id = crypto.randomUUID();
      } else {
        id = `anon_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      }
      localStorage.setItem(key, id);
      return id;
    },
    checkWxAuth() {
      const userInfo = localStorage.getItem('yunhai_user');

      const routePath = (this.$route && this.$route.path) ? this.$route.path : '';
      const pathname = (typeof window !== 'undefined' && window.location) ? (window.location.pathname || '') : '';
      const hash = (typeof window !== 'undefined' && window.location) ? (window.location.hash || '') : '';
      const hashPath = hash.startsWith('#') ? hash.slice(1) : hash;

      const isAdminRoute =
        routePath === '/admin' ||
        routePath.startsWith('/admin/') ||
        pathname === '/admin' ||
        pathname.startsWith('/admin/') ||
        hashPath === '/admin' ||
        hashPath.startsWith('/admin/');

      const isAuthRoute = routePath === '/auth' || pathname === '/auth' || hashPath === '/auth';

      if (!userInfo && !isAuthRoute && !isAdminRoute) {
        this.ensureAnonymousId();
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}

#app {
  min-height: 100vh;
}
</style>
nav {
  padding: 30px;
}
